module.exports = __webpack_public_path__ + "img/aramultimedia.2ed356d1.png";